package com.hyperether.goodjob.util

enum class UploadStatus {
    NONE,
    LOADING,
    UPLOADED,
    ERROR,
}